import { colors } from '../../constants.js/colors';
import styled from '@emotion/styled';
import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

export const NameCell = styled(TableCell)`
    overflow: visible;
    vertical-align: middle;
    position: relative;
`;

export const AddNewProduct = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 24px;
    justify-content: space-between;
`;
export const ProductImage = styled.img`
    width: 48px;
    height: 48px;
    border-radius: 8px;
    object-fit: cover;
    border: 1px solid #e8ece9;
    transition: transform 0.3s ease, box-shadow 0.2s ease;
    position: relative;
    transform: scale(1);
    cursor: zoom-in;
    background: #f3f5f4;

    &:hover {
        z-index: 30;
        box-shadow: 0 8px 24px rgba(23, 51, 0, 0.18);
        transform: scale(4) translateX(15px) translateY(14px);
        border-radius: 8px;
    }

    ${({ isLast }) =>
        isLast &&
        `
    &:hover {
      transform: scale(4) translateX(15px) translateY(-14px);
    }
  `}
`;

export const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: '100%',
        background: '#ffffff',
        overflow: 'hidden',
    },
    tableSection: {
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
        boxSizing: 'border-box',
    },
    tableCard: {
        border: `1px solid ${colors.gray.main}`,
        borderRadius: 12,
        backgroundColor: colors.white,
        boxShadow: '0px 1px 3px rgba(52, 58, 67, 0.06)',
    },
    container: {
        maxHeight: 'calc(100vh - 280px)',
        maxWidth: '100%',
        width: '100%',
        overflowX: 'hidden',
        overflowY: 'auto',
        background: colors.white,
        '& .MuiTableBody-root': {
            overflow: 'visible',
        },
    },
    table: {
        tableLayout: 'fixed',
        width: '100%',
        '& .MuiTableHead-root .MuiTableCell-head': {
            backgroundColor: colors.lightGray,
            color: colors.gray.alternative,
            fontSize: '0.6875rem',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            borderBottom: `1px solid ${colors.gray.main}`,
            padding: theme.spacing(1.25, 1),
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        '& .MuiTableBody-root .MuiTableCell-root': {
            padding: theme.spacing(1.25, 1),
            borderBottom: `1px solid ${colors.gray.main}`,
            fontSize: '0.875rem',
            verticalAlign: 'middle',
            overflow: 'hidden',
        },
        [theme.breakpoints.down('lg')]: {
            '& .MuiTableHead-root .MuiTableCell-head': {
                padding: theme.spacing(1, 0.75),
                fontSize: '0.6875rem',
            },
            '& .MuiTableBody-root .MuiTableCell-root': {
                padding: theme.spacing(1, 0.75),
                fontSize: '0.875rem',
            },
        },
        '& .MuiTableBody-root .MuiTableRow-root': {
            position: 'relative',
        },
        '& .MuiTableBody-root .MuiTableRow-root:hover': {
            position: 'relative',
            zIndex: 12,
        },
        '& .MuiTableCell-paddingCheckbox': {
            padding: 0,
            width: 'auto',
        },
        '& .MuiTableRow-hover:hover': {
            backgroundColor: '#f3f6f4',
        },
    },
    rowSelected: {
        backgroundColor: 'rgba(158, 232, 112, 0.14) !important',
    },
    cellTruncate: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    colCheckbox: {
        padding: 0,
        width: 'auto',
    },
    colName: {
        width: '20%',
        overflow: 'visible',
        paddingLeft: theme.spacing(1),
        paddingRight: 0,
        [theme.breakpoints.down('lg')]: {
            width: '21%',
            paddingLeft: theme.spacing(0.75),
        },
    },
    nameTableCell: {
        overflow: 'visible !important',
    },
    listHeaderCheckbox: {
        flexShrink: 0,
        padding: 6,
        marginLeft: -6,
        marginRight: theme.spacing(0.25),
        visibility: 'hidden',
        pointerEvents: 'none',
        [theme.breakpoints.down('lg')]: {
            padding: 4,
            marginLeft: -4,
        },
    },
    nameHeaderImageSpacer: {
        flexShrink: 0,
        width: 48,
        height: 48,
        marginRight: theme.spacing(1),
    },
    nameCellInner: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.75),
        minWidth: 0,
        overflow: 'visible',
        '& img': {
            flexShrink: 0,
            marginRight: theme.spacing(1),
            position: 'relative',
        },
    },
    rowCheckbox: {
        flexShrink: 0,
        padding: 6,
        marginLeft: -6,
        marginRight: theme.spacing(0.25),
        [theme.breakpoints.down('lg')]: {
            padding: 4,
            marginLeft: -4,
        },
    },
    nameCellText: {
        minWidth: 0,
        flex: 1,
        overflow: 'hidden',
        '& a': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'block',
            fontWeight: 500,
            color: colors.text.primary,
            textDecoration: 'none',
            '&:hover': {
                color: colors.text.secondary,
                textDecoration: 'underline',
            },
        },
    },
    colCategory: {
        width: '15%',
        paddingLeft: theme.spacing(0.75),
        paddingRight: theme.spacing(0.25),
        [theme.breakpoints.down('lg')]: {
            width: '14%',
            paddingLeft: theme.spacing(0.5),
        },
    },
    colSubcategory: {
        width: '14%',
        paddingRight: theme.spacing(0.25),
        [theme.breakpoints.down('lg')]: {
            width: '13%',
        },
    },
    colSku: {
        width: '12%',
        [theme.breakpoints.down('lg')]: {
            width: '11%',
        },
    },
    colStatus: {
        width: '8%',
        textAlign: 'center',
        [theme.breakpoints.down('lg')]: {
            width: '8%',
        },
    },
    colPrice: {
        width: '10%',
        textAlign: 'right',
        [theme.breakpoints.down('lg')]: {
            width: '10%',
        },
    },
    colEdit: {
        width: '7%',
        textAlign: 'center',
        [theme.breakpoints.down('lg')]: {
            width: '7%',
        },
    },
    statusSwitchWrap: {
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 42,
        minHeight: 28,
    },
    statusSwitchSpinner: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
    },
    buttonLoadingWrap: {
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    buttonLoadingLabelHidden: {
        opacity: 0,
    },
    buttonLoadingSpinner: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'inline-flex',
        lineHeight: 0,
    },
    editButton: {
        color: colors.text.secondary,
        backgroundColor: 'rgba(158, 232, 112, 0.15)',
        padding: 8,
        '&:hover': {
            backgroundColor: 'rgba(158, 232, 112, 0.3)',
        },
        '&.Mui-disabled': {
            backgroundColor: colors.gray.main,
            color: colors.gray.dark,
        },
        [theme.breakpoints.down('lg')]: {
            padding: 6,
        },
    },
    skuText: {
        fontSize: '0.8125rem',
        color: colors.gray.alternative,
    },
    priceText: {
        fontWeight: 600,
        color: colors.text.primary,
    },
    collectionBadge: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        backgroundColor: 'rgba(158, 232, 112, 0.18)',
        color: colors.text.secondary,
        padding: '4px 10px',
        borderRadius: 999,
        fontSize: '0.75rem',
        fontWeight: 500,
        lineHeight: 1.3,
        [theme.breakpoints.down('lg')]: {
            padding: '3px 8px',
        },
    },
    subcategoryBadge: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        backgroundColor: colors.lightGray,
        color: colors.gray.alternative,
        padding: '4px 10px',
        borderRadius: 999,
        fontSize: '0.75rem',
        fontWeight: 500,
        lineHeight: 1.3,
        [theme.breakpoints.down('lg')]: {
            padding: '3px 8px',
        },
    },
    spacer: {
        '& .MuiTablePagination-spacer': {
            flex: 0,
        },
    },
    filterInput: {
        backgroundColor: '#fff',
        borderRadius: 8,
        boxShadow:
            '0px 0px 2px rgba(52, 58, 67, 0.1), 0px 1px 2px rgba(52, 58, 67, 0.08), 0px 1px 4px rgba(52, 58, 67, 0.08)',
        color: '#53627C',
        height: 42,
        padding: '14px 16px',
        width: '100%',
    },
    buttonContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        justifyContent: 'flex-end',
    },
    actionButton: {
        marginBottom: '8px',
    },
    thinButton: {
        padding: '4px 7px',
        height: '32px',
        lineHeight: 1,
        fontSize: '0.8125rem',
        '& .MuiButton-label': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        '& .MuiButton-startIcon': {
            marginRight: 8,
            marginLeft: 0,
        },
        '& .MuiSvgIcon-root': {
            fontSize: '1.2rem', // Smaller icons
        },
        '& img': {
            width: 16,
            height: 16,
            objectFit: 'contain',
        },
    },
    deleteButton: {
        background: colors.error.main,
        color: colors.white,
        '&:hover': {
            background: colors.error.dark,
        },
    },
    bulkActionsBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        padding: theme.spacing(1.5, 2),
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        backgroundColor: '#f7f9f8',
        borderBottom: `1px solid ${colors.gray.main}`,
    },
    selectionBarLeft: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        flex: 1,
        minWidth: 0,
    },
    selectAllButton: {
        textTransform: 'none',
        fontWeight: 500,
        fontSize: '0.8125rem',
        padding: '5px 14px',
        minHeight: 34,
        lineHeight: 1.25,
        borderColor: colors.text.secondary,
        color: colors.text.secondary,
        '&:hover': {
            borderColor: colors.text.primary,
            backgroundColor: colors.lightGray,
        },
    },
    bulkActionsButtons: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        '& > .MuiButton-root:not(:first-of-type)': {
            marginLeft: 14,
        },
    },
    bulkSelectionText: {
        fontWeight: 500,
        color: colors.text.primary,
        fontSize: 13,
        whiteSpace: 'nowrap',
        marginLeft: theme.spacing(2),
    },
    bulkSelectRow: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(2),
    },
    bulkSelectCount: {
        marginLeft: theme.spacing(2),
    },
    bulkSelectionMuted: {
        color: colors.gray.alternative,
    },
    tablePagination: {
        borderTop: `1px solid ${colors.gray.main}`,
        backgroundColor: colors.white,
    },
    bulkButtonBase: {
        textTransform: 'none',
        fontWeight: 500,
        fontSize: '0.8125rem',
        padding: '5px 14px',
        minHeight: 34,
        lineHeight: 1.25,
        boxShadow: 'none',
        position: 'relative',
    },
    bulkActivateButton: {
        backgroundColor: colors.primary.main,
        color: colors.text.secondary,
        '&:hover': {
            backgroundColor: colors.primary.aquamarine,
            boxShadow: 'none',
        },
        '&:disabled': {
            backgroundColor: colors.gray.main,
            color: colors.gray.dark,
        },
    },
    bulkDeactivateButton: {
        border: `1px solid ${colors.text.secondary}`,
        color: colors.text.secondary,
        backgroundColor: colors.white,
        '&:hover': {
            backgroundColor: colors.lightGray,
            borderColor: colors.text.secondary,
        },
        '&:disabled': {
            borderColor: colors.gray.light,
            color: colors.gray.dark,
        },
    },
    bulkDeleteButton: {
        background: colors.error.main,
        color: colors.white,
        '&:hover': {
            background: colors.error.dark,
            boxShadow: 'none',
        },
        '&:disabled': {
            background: colors.gray.main,
            color: colors.gray.dark,
        },
    },
    emptyCell: {
        color: '#9aa0a6',
    },
    priceSortLabel: {
        cursor: 'pointer',
        userSelect: 'none',
        '& .MuiTableSortLabel-icon': {
            opacity: '0.45 !important',
        },
        '&:hover': {
            color: colors.text.primary,
        },
        '&:hover .MuiTableSortLabel-icon': {
            opacity: '0.75 !important',
        },
    },
    priceSortLabelActive: {
        '& .MuiTableSortLabel-icon': {
            opacity: '1 !important',
        },
    },
    mobileRoot: {
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        padding: '12px 0 100px 0',
    },
    header: {
        backgroundColor: '#fff',
        borderBottom: '1px solid #e0e0e0',
        position: 'sticky',
        top: 0,
        zIndex: 100,
    },
    headerContent: {
        padding: theme.spacing(2, 2.5),
    },
    searchBox: {
        marginBottom: theme.spacing(2) + 'px',
    },
    buttonGroup: {
        display: 'flex',
        gap: theme.spacing(1.5),
        alignItems: 'stretch',
        '& > .MuiButton-root:first-child': {
            flex: 1,
        },
        '& > .MuiButton-outlined': {
            flexShrink: 0,
            minWidth: 108,
        },
    },
    actionBarContainer: {
        padding: theme.spacing(0, 2.5, 1),
        // ✅ Hide scrollbar on all browsers
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        '-ms-overflow-style': 'none', // IE and Edge
        'scrollbar-width': 'none', // Firefox
    },
    actionBar: {
        backgroundColor: '#f5f5f5',
        padding: theme.spacing(1.25, 0),
        borderBottom: '1px solid #e0e0e0',
        display: 'flex',
        flexWrap: 'nowrap',
        gap: theme.spacing(1.25),
        whiteSpace: 'nowrap',
        WebkitOverflowScrolling: 'touch',
        touchAction: 'pan-x',
        width: '100%',
        boxSizing: 'border-box',
        position: 'relative',
        '& > *': {
            flexShrink: 0,
            minWidth: 'fit-content',
        },
    },
    actionBarHint: {
        marginTop: theme.spacing(1),
        paddingLeft: 0,
        paddingRight: 0,
        lineHeight: 1.45,
        maxWidth: '100%',
    },
    filterButton: {
        textTransform: 'none',
        whiteSpace: 'nowrap',
    },
    progressBanner: {
        margin: theme.spacing(2, 2.5),
        padding: theme.spacing(2),
        backgroundColor: 'rgba(115, 237, 184, 0.1)',
        border: '1px solid rgba(115, 237, 184, 0.3)',
        borderRadius: theme.spacing(1.5) + 'px',
    },
    statsGrid: {
        display: 'flex',
        gap: theme.spacing(1),
        alignItems: 'center',
        padding: theme.spacing(0, 2.5, 2),
        flexWrap: 'nowrap',
    },
    statCard: {
        textAlign: 'center',
        backgroundColor: '#f9f9f9',
    },
    statNumber: {
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: theme.spacing(0.5) + 'px',
    },
    statLabel: {
        fontSize: '12px',
        color: '#999',
    },
    productList: {
        padding: theme.spacing(0, 2.5, 10),
    },
    productCard: {
        marginBottom: theme.spacing(2) + 'px',
        display: 'flex',
        gap: theme.spacing(1) + 'px',
        padding: '12px',
        flexDirection: 'column',
    },
    productImage: {
        width: 80,
        height: 80,
        borderRadius: theme.spacing(1) + 'px',
        backgroundColor: '#f0f0f0',
        flexShrink: 0,
        objectFit: 'cover',
    },
    productInfo: {
        flex: 1,
    },
    productTitle: {
        fontWeight: 600,
    },
    productSku: {
        fontSize: '12px',
        color: '#999',
    },
    categoryBadge: {
        display: 'inline-block',
        backgroundColor: 'rgba(158, 232, 112, 0.2)',
        color: '#173300',
        padding: '4px 8px',
        borderRadius: 4,
        fontSize: '11px',
        marginRight: theme.spacing(1) + 'px',
    },
    stockText: {
        fontSize: '11px',
        color: '#999',
    },
    productPrice: {
        fontSize: '18px',
        fontWeight: 'bold',
    },
    productActions: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
    },
    productActionItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
    },
    productActionLabel: {
        fontSize: '10px',
        color: '#666',
        lineHeight: 1,
    },
    bottomNav: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        borderTop: '1px solid #e0e0e0',
        backgroundColor: '#fff',
    },
    whatsappFab: {
        position: 'fixed',
        bottom: 80,
        right: 16,
        backgroundColor: '#25D366',
        '&:hover': {
            backgroundColor: '#1fa855',
        },
    },
    bulkBar: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: '#173300',
        color: 'white',
        padding: theme.spacing(1.5, 2) + 'px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: 101,
    },
    dialog: {
        '& .MuiDialog-paper': {
            borderRadius: theme.spacing(2) + 'px',
        },
    },
}));
